import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Link2, Save, Search } from 'lucide-react';

export const PropertyLinksPanel = ({ properties, onSave }) => {
  const [search, setSearch] = useState('');
  const [drafts, setDrafts] = useState({});
  useEffect(() => setDrafts(Object.fromEntries(properties.map(p => [p.id, p.hw_academy_valuation_id || '']))), [properties]);
  const needle = search.trim().toLowerCase();
  const rows = properties.filter(p => !needle || [p.property_code, p.name, p.city].some(v => String(v || '').toLowerCase().includes(needle)));

  return <section data-testid="academy-property-links-panel">
    <div className="mb-4 flex max-w-md items-center gap-2 border-b pb-2">
      <Search className="h-4 w-4 text-slate-400" />
      <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Cerca immobile, codice o città"
        className="w-full bg-transparent text-sm outline-none" data-testid="academy-property-search-input" />
    </div>
    <div className="divide-y border-y">{rows.map((property) => <div key={property.id} className="grid gap-3 py-3 md:grid-cols-[1.4fr_1fr_auto] md:items-center" data-testid={`academy-property-link-${property.id}`}>
      <div><p className="font-semibold text-slate-900">{property.property_code} · {property.name}</p><p className="text-xs text-slate-500">{[property.city, property.province, property.region].filter(Boolean).join(' · ')}</p></div>
      <label className="text-xs font-semibold text-slate-600"><span className="flex items-center gap-1"><Link2 className="h-3 w-3" /> ID valutazione Academy</span>
        <input value={drafts[property.id] ?? ''} onChange={(e) => setDrafts(d => ({ ...d, [property.id]: e.target.value }))}
          placeholder="Es. HW-123" className="mt-1 w-full rounded-md border px-3 py-2 text-sm" data-testid={`academy-property-link-input-${property.id}`} />
      </label>
      <Button size="sm" variant="outline" onClick={() => onSave(property.id, drafts[property.id] || null)} data-testid={`academy-property-link-save-${property.id}`}>
        <Save className="mr-1 h-4 w-4" /> Salva
      </Button>
    </div>)}</div>
    {!rows.length && <p className="py-12 text-center text-sm text-slate-500" data-testid="academy-property-links-empty">Nessun immobile trovato.</p>}
  </section>;
};
